var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "react", "prop-types", "./MultiLineSlider.css", "./BaseMultiLineSlider", "../../UI/TitlesElement/TitlesElement"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("react"), require("prop-types"), require("./MultiLineSlider.css"), require("./BaseMultiLineSlider"), require("../../UI/TitlesElement/TitlesElement"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.propTypes, global.MultiLineSlider, global.BaseMultiLineSlider, global.TitlesElement);
    global.MultiLineSlideBig = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _react, _propTypes, _MultiLineSlider, _BaseMultiLineSlider, _TitlesElement) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var MultiLineSlideBig = function MultiLineSlideBig(_ref) {
    var teaser = _ref.teaser,
        placeholders = _ref.placeholders,
        breakpointFormat = _ref.breakpointFormat,
        visible = _ref.visible;
    var GenericTeaser = (0, _BaseMultiLineSlider.getTeaserFromKind)(teaser.kind);
    return /*#__PURE__*/_react.default.createElement(_MultiLineSlider.StyledSlideBig, null, /*#__PURE__*/_react.default.createElement(GenericTeaser, (0, _extends2.default)({
      className: "next-teaser-overlay",
      hover: "overlayRGAA",
      breakpointFormat: breakpointFormat,
      titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.TitlesElement, {
        isPlaceholder: placeholders > 0,
        display: "OVERLAY",
        slideKind: teaser.kind ? teaser.kind.code : null,
        title: teaser.title,
        subtitle: teaser.subtitle
      }),
      visible: visible
    }, teaser)));
  };

  MultiLineSlideBig.propTypes = {
    teaser: _propTypes.default.shape().isRequired,
    breakpointFormat: _propTypes.default.shape({
      small: _propTypes.default.string,
      medium: _propTypes.default.string,
      large: _propTypes.default.string,
      xlarge: _propTypes.default.string,
      xxlarge: _propTypes.default.string
    }).isRequired,
    placeholders: _propTypes.default.number,
    visible: _propTypes.default.bool
  };
  var _default = MultiLineSlideBig;
  _exports.default = _default;
});